import methodBuilder from "./method";
class Controller {
  constructor(schema) {
    Object.keys(schema).forEach((method) => {
      this[method] = methodBuilder(method, schema[method]);
    });
  }
}
export default Controller;
